// import data from "../data/data.json";

import { Swiper } from "react-vant";
import Zmage from 'react-zmage'
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import '../css/first.css';

// const data = require('../data/data.json');





function Index() {

    const [data, setData] = useState(null);

    useEffect(() => {

        // 在这里加载JSON文件
        fetch('/data/data.1.json')
            .then(response => response.json())
            .then(data => {
                setData(data)
            })
            .catch(error => console.error('Error loading JSON:', error));
    }, []);
    // 列表背景样式
    const bgStyle = {
        backgroundImage: "url(" + require('../img/lists/huawendi.jpg'),
        width: "100%",
        backgroundSize: '100%',
        backgroundRepeat: 'repeat',
        display: "flex",
        justifyContent: "center"
    }
    // 轮播部分
    let type = data !== null ? data.swiper.map((number) =>
        <Swiper.Item key={number.id}>
            {number.type === 1 ?
                <img draggable={false} className='bg' key={number.id} alt='' src={require('../img/' + number.url)}></img> :
                <div>
                    <img draggable={false} className='bg' key={number.id} alt='' src={require('../img/' + number.url)}></img>
                    {/* 两个二维码 */}
                    <div className='qrBox'>

                        <div className='qr'>
                            <Zmage draggable={false} className='qr' src={require('../img/gongzhonghao.jpg')} alt='' />
                            <div>官方公众号</div>
                        </div>
                        <div className='qr'>
                            <Zmage draggable={false} className='qr' src={require('../img/kefu2.png')} alt='' />
                            <div>微信客服<br />{data.kefuNum}</div>
                        </div>
                    </div>
                    <div className='auditon' onClick={playGameHaiXuan}>
                        <img draggable={false} className="cursor" alt='' src={require('../img/haixuan.png')}></img>
                        {/* <div className='auditonText'>报名海选</div> */}
                        <img draggable={false} className='auditonText cursor' alt='' src={require('../img/baominghaixuan.png')}></img>
                    </div>
                </div>
            }
        </Swiper.Item>
    ) : "";
    // 游戏列表部分
    let lists = data !== null ? data.icon.map((el) => {
        return <div key={el.id}>
            <div style={{ "position": "relative", "margin": "14% 20px", width: "221px", height: "221px" }}>
                <img draggable={false} className='xiaodi' alt='' src={require('../img/lists/xiaodi.png')}></img>
                <img draggable={false} className='jiwan' alt='' src={require('../img/lists/jiwan.png')}></img>
                <img draggable={false} className='icon' alt='' src={require('../img/lists/' + el.url)}></img>
                <div style={{ width: "100%", height: "100%", position: "absolute", zIndex: 30 }} onClick={() => { playGameHandle(el) }} className="cursor">

                </div>
            </div>

        </div>

    }) : ""

    // 点击游戏列表事件
    function playGameHandle(el) {


        if (!el.enable) {
            toast.error('暂未开启!');
        } else {
            if (data.playGameLink != "") {
                window.location.href = data.playGameLink+Date.now()
            } else {
                toast.error('链接未配置!');
            }
        }

        // toast.success('操作成功!');
        // toast.error('发生错误!');
        // toast.warn('警告!');
        // toast.info('通知信息!');
        // window.location.href = data.playGameLink
    }
    // 点击立即游戏事件
    function playGameHaiXuan() {

        let number = 0
        data.icon.forEach(element => {
            if (element.enable) {
                if (data.playGameLink != "") {
                    window.location.href = data.playGameLink+Date.now()
                } else {
                    toast.error('链接未配置!');
                }
            }
            if (!element.enable) {
                number++
            }
        });
        if (number == data.icon.length) {
            toast.error('暂未开启!');
            console.log("暂未开启!");
        }

        // toast.success('操作成功!');
        // toast.error('发生错误!');
        // toast.warn('警告!');
        // toast.info('通知信息!');
        // window.location.href = data.playGameLink
    }




    return (
        // <Container>

        <div className='max'>
            {/* 头部 */}
            {/* 轮播，游戏列表 */}
            <main className=''>
                {/* 轮播 */}
                {/* <Swiper className='swiper'>
                    {type !== "" ? type : ""}
                </Swiper> */}
                {/* 非轮播 */}
                <div style={{position:"relative"}}>
                    <div className='swiper'>
                        <img draggable={false} className='bg' alt='' src={require('../img/bg1.png' )}></img>
                        {/* 两个二维码 */}
                        <div className='qrBox'>

                            <div className='qr'>
                                <Zmage draggable={false} className='qr' src={require('../img/gongzhonghao.jpg')} alt='' />
                                <div>官方公众号</div>
                            </div>
                            <div className='qr'>
                                <Zmage draggable={false} className='qr' src={require('../img/kefu2.png')} alt='' />
                                <div>微信客服<br />{data?data.kefuNum:""}</div>
                            </div>
                        </div>
                        <div className='auditon' onClick={playGameHaiXuan}>
                            <img draggable={false} className="cursor" alt='' src={require('../img/haixuan.png')}></img>
                            {/* <div className='auditonText'>报名海选</div> */}
                            <img draggable={false} className='auditonText cursor' alt='' src={require('../img/baominghaixuan.png')}></img>
                        </div>
                    </div>
                </div>
                {/* 游戏列表 */}
                <div style={bgStyle} >
                    <div>
                        <div style={{ "width": "88.9%", "display": "flex", "margin": "30px auto 10px", "justifyContent": "space-between" }}>
                            <div className='line'></div>
                            <img draggable={false} alt='' src={require('../img/lists/zhendi.png')}></img>
                            <div className='line'></div>
                        </div>
                        <div className='bgStyle'>{lists !== "" ? lists : ""}</div>
                    </div>
                </div>
            </main>

        </div>
        // </Container>
    );
}

export default Index;
